import { createContext, type ReactNode, useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

const PreviousLocationContext = createContext<string | null>(null)

// Provider component to track and provide the previous location in the app
export const PreviousLocationProvider = ({ children }: { children: ReactNode }) => {
  const location = useLocation()
  const [previousLocation, setPreviousLocation] = useState<string | null>(null)
  const [lastRecordedLocation, setLastRecordedLocation] = useState<string | null>(null)
  const currentLocation = location.pathname + location.search + location.hash

  useEffect(() => {
    // Update previousLocation only if the location has changed
    if (lastRecordedLocation && lastRecordedLocation !== currentLocation) {
      setPreviousLocation(lastRecordedLocation)
    }
    // Always update lastRecordedLocation to the current location
    setLastRecordedLocation(currentLocation)
  }, [currentLocation])

  return (
    <PreviousLocationContext.Provider value={previousLocation}>
      {children}
    </PreviousLocationContext.Provider>
  )
}

export const usePreviousLocation = (fallbackLocation: string) => {
  const contextValue = useContext(PreviousLocationContext)
  return contextValue ?? fallbackLocation
}
